import { Injectable } from '@angular/core';
import { TableDatasource } from '@core/api/table.datasource';
import { LetsikringSearchParams } from './letregister-search/letsikring-search-params.model';
import { Letsikring } from './letsikring.model';

@Injectable({
  providedIn: 'root',
})
export class LetsikringDatasource extends TableDatasource<
  Letsikring,
  LetsikringSearchParams
> {
  endpoint = '/api/admin/letsikringer';
  defaultSortField = 'letsikringNr';
}
